class Newsletter extends App.Component {
    constructor(container) {
        super(container);
        let $form = $('form', container);
        $form.submit(function(e) {
            if(!window.checkCaptchas(this)) return;
            e.preventDefault();
            $.ajax({
                method: 'POST',
                url: this.action,
                data: $form.serialize(),
                dataType: 'json',
                success: function(data) {
                    if(data.messageType === 'success') {
                        $form.closest('.newsletter-section').html(
                            App.Template.parse('newsletter-registered')
                        );
                    } else {
                        let Form = $form[0].getComponent();
                        let Email = Form.groups['email'];
                        Email.setNotification(data.message, data.messageType);
                    }
                }
            });
        });
    }
}

App.Components.register('.newsletter-container', Newsletter);